import { VERSION } from './appConstants';
import { STORAGE_URL } from './config';

const buildImgUrl = (path: string) =>
  `${STORAGE_URL}/${path.replace('/', '%2F')}?alt=media&v=${VERSION}`;

export function buildingsImageRequire(name: string) {
  return {
    uri: buildImgUrl(`buildings/${name}`),
  };
  // switch (name) {
  //   case 'darkCastle.jpg':
  //     return require('../assets/buildings/darkCastle.jpg');
  //   default:
  //     return null;
  // }
}

export function islandImageRequire(name: string) {  
  return {
    uri: buildImgUrl(`islands/${name}`),
  };
  // switch (name) {
  //   case 'dragonIsland.png':
  //     return require('../assets/islands/dragonIsland.png');
  //   default:
  //     return null;
  // }
}

export function warriorImageRequire(name: string) {
  return {
    //uri: require('../assets/warriors/payAvatar1.png') //buildImgUrl(`warriors/${name}`),
    uri: buildImgUrl(`warriors/${name}`),
  };
  // switch (name) {
  //   case 'warrior0.png':
  //     return require('../assets/warriors/warrior0.png');
  //   case 'warrior1.png':
  //     return require('../assets/warriors/warrior1.png');
  //   case 'warrior2.png':
  //     return require('../assets/warriors/warrior2.png');
  //   case 'warrior3.png':
  //     return require('../assets/warriors/warrior3.png');
  //   case 'warrior4.png':
  //     return require('../assets/warriors/warrior4.png');
  //   case 'warrior5.png':
  //     return require('../assets/warriors/warrior5.png');
  //   case 'warrior6.png':
  //     return require('../assets/warriors/warrior6.png');
  //   case 'warrior7.png':
  //     return require('../assets/warriors/warrior7.png');
  //   case 'warrior8.png':
  //     return require('../assets/warriors/warrior8.png');
  //   default:
  //     return null;
  // }
}

export function thingImageRequire(name: string) {
  return {
    uri: buildImgUrl(`things/${name}`),
  };
  // switch (name) {
  //   case 'gloves0.png':
  //     return require('../assets/things/gloves0.png');
  //   case 'gloves1.png':
  //     return require('../assets/things/gloves1.png');
  //   case 'gloves2.png':
  //     return require('../assets/things/gloves2.png');
  //   case 'gloves3.png':
  //     return require('../assets/things/gloves3.png');

  //   case 'armor0.png':
  //     return require('../assets/things/armor0.png');
  //   case 'armor1.png':
  //     return require('../assets/things/armor1.png');
  //   case 'armor2.png':
  //     return require('../assets/things/armor2.png');
  //   case 'armor3.png':
  //     return require('../assets/things/armor3.png');
  //   case 'armor4.png':
  //     return require('../assets/things/armor4.png');
  //   case 'armor5.png':
  //     return require('../assets/things/armor5.png');
  //   case 'armor6.png':
  //     return require('../assets/things/armor6.png');
  //   case 'armor7.png':
  //     return require('../assets/things/armor7.png');
  //   case 'armor8.png':
  //     return require('../assets/things/armor8.png');
  //   case 'armor9.png':
  //     return require('../assets/things/armor9.png');

  //   case 'helmet0.png':
  //     return require('../assets/things/helmet0.png');
  //   case 'helmet1.png':
  //     return require('../assets/things/helmet1.png');
  //   case 'helmet2.png':
  //     return require('../assets/things/helmet2.png');
  //   case 'helmet3.png':
  //     return require('../assets/things/helmet3.png');
  //   case 'helmet4.png':
  //     return require('../assets/things/helmet4.png');
  //   case 'helmet5.png':
  //     return require('../assets/things/helmet5.png');
  //   case 'helmet6.png':
  //     return require('../assets/things/helmet6.png');
  //   case 'helmet7.png':
  //     return require('../assets/things/helmet7.png');
  //   case 'helmet8.png':
  //     return require('../assets/things/helmet8.png');
  //   case 'helmet9.png':
  //     return require('../assets/things/helmet9.png');
  //   case 'helmet10.png':
  //     return require('../assets/things/helmet10.png');
  //   case 'helmet11.png':
  //     return require('../assets/things/helmet11.png');
  //   case 'helmet12.png':
  //     return require('../assets/things/helmet12.png');
  //   case 'helmet13.png':
  //     return require('../assets/things/helmet13.png');
  //   case 'helmet14.png':
  //     return require('../assets/things/helmet14.png');
  //   case 'helmet15.png':
  //     return require('../assets/things/helmet15.png');

  //   case 'amulet0.png':
  //     return require('../assets/things/amulet0.png');
  //   case 'amulet1.png':
  //     return require('../assets/things/amulet1.png');
  //   case 'amulet2.png':
  //     return require('../assets/things/amulet2.png');
  //   case 'amulet3.png':
  //     return require('../assets/things/amulet3.png');
  //   case 'amulet4.png':
  //     return require('../assets/things/amulet4.png');
  //   case 'amulet5.png':
  //     return require('../assets/things/amulet5.png');
  //   case 'amulet6.png':
  //     return require('../assets/things/amulet6.png');
  //   case 'amulet7.png':
  //     return require('../assets/things/amulet7.png');
  //   case 'amulet8.png':
  //     return require('../assets/things/amulet8.png');

  //   case 'axe0.png':
  //     return require('../assets/things/axe0.png');
  //   case 'axe1.png':
  //     return require('../assets/things/axe1.png');
  //   case 'axe2.png':
  //     return require('../assets/things/axe2.png');
  //   case 'axe3.png':
  //     return require('../assets/things/axe3.png');
  //   case 'axe4.png':
  //     return require('../assets/things/axe4.png');
  //   case 'axe5.png':
  //     return require('../assets/things/axe5.png');
  //   case 'axe6.png':
  //     return require('../assets/things/axe6.png');
  //   case 'axe7.png':
  //     return require('../assets/things/axe7.png');
  //   case 'axe8.png':
  //     return require('../assets/things/axe8.png');
  //   case 'axe9.png':
  //     return require('../assets/things/axe9.png');
  //   case 'axe10.png':
  //     return require('../assets/things/axe10.png');

  //   case 'belt0.png':
  //     return require('../assets/things/belt0.png');
  //   case 'belt1.png':
  //     return require('../assets/things/belt1.png');

  //   case 'boots0.png':
  //     return require('../assets/things/boots0.png');
  //   case 'boots1.png':
  //     return require('../assets/things/boots1.png');
  //   case 'boots2.png':
  //     return require('../assets/things/boots2.png');
  //   case 'boots3.png':
  //     return require('../assets/things/boots3.png');
  //   case 'boots4.png':
  //     return require('../assets/things/boots4.png');
  //   case 'boots5.png':
  //     return require('../assets/things/boots5.png');
  //   case 'boots6.png':
  //     return require('../assets/things/boots6.png');

  //   case 'bracer0.png':
  //     return require('../assets/things/bracer0.png');
  //   case 'bracer1.png':
  //     return require('../assets/things/bracer1.png');
  //   case 'bracer2.png':
  //     return require('../assets/things/bracer2.png');
  //   case 'bracer3.png':
  //     return require('../assets/things/bracer3.png');
  //   case 'bracer4.png':
  //     return require('../assets/things/bracer4.png');
  //   case 'bracer5.png':
  //     return require('../assets/things/bracer5.png');

  //   case 'clubs0.png':
  //     return require('../assets/things/clubs0.png');
  //   case 'clubs1.png':
  //     return require('../assets/things/clubs1.png');
  //   case 'clubs2.png':
  //     return require('../assets/things/clubs2.png');
  //   case 'clubs3.png':
  //     return require('../assets/things/clubs3.png');
  //   case 'clubs4.png':
  //     return require('../assets/things/clubs4.png');
  //   case 'clubs5.png':
  //     return require('../assets/things/clubs5.png');
  //   case 'clubs6.png':
  //     return require('../assets/things/clubs6.png');

  //   case 'knife0.png':
  //     return require('../assets/things/knife0.png');
  //   case 'knife1.png':
  //     return require('../assets/things/knife1.png');
  //   case 'knife2.png':
  //     return require('../assets/things/knife2.png');
  //   case 'knife3.png':
  //     return require('../assets/things/knife3.png');
  //   case 'knife4.png':
  //     return require('../assets/things/knife4.png');
  //   case 'knife5.png':
  //     return require('../assets/things/knife5.png');
  //   case 'knife6.png':
  //     return require('../assets/things/knife6.png');
  //   case 'knife7.png':
  //     return require('../assets/things/knife7.png');
  //   case 'knife8.png':
  //     return require('../assets/things/knife8.png');
  //   case 'knife9.png':
  //     return require('../assets/things/knife9.png');
  //   case 'knife10.png':
  //     return require('../assets/things/knife10.png');
  //   case 'knife11.png':
  //     return require('../assets/things/knife11.png');
  //   case 'knife12.png':
  //     return require('../assets/things/knife12.png');
  //   case 'knife13.png':
  //     return require('../assets/things/knife13.png');
  //   case 'knife14.png':
  //     return require('../assets/things/knife14.png');
  //   case 'knife15.png':
  //     return require('../assets/things/knife15.png');
  //   case 'knife16.png':
  //     return require('../assets/things/knife16.png');
  //   case 'knife17.png':
  //     return require('../assets/things/knife17.png');

  //   case 'pants0.png':
  //     return require('../assets/things/pants0.png');
  //   case 'pants1.png':
  //     return require('../assets/things/pants1.png');

  //   case 'ring0.png':
  //     return require('../assets/things/ring0.png');
  //   case 'ring1.png':
  //     return require('../assets/things/ring1.png');
  //   case 'ring2.png':
  //     return require('../assets/things/ring2.png');
  //   case 'ring3.png':
  //     return require('../assets/things/ring3.png');
  //   case 'ring4.png':
  //     return require('../assets/things/ring4.png');
  //   case 'ring5.png':
  //     return require('../assets/things/ring5.png');
  //   case 'ring6.png':
  //     return require('../assets/things/ring6.png');
  //   case 'ring7.png':
  //     return require('../assets/things/ring7.png');

  //   case 'shield0.png':
  //     return require('../assets/things/shield0.png');
  //   case 'shield1.png':
  //     return require('../assets/things/shield1.png');
  //   case 'shield2.png':
  //     return require('../assets/things/shield2.png');
  //   case 'shield3.png':
  //     return require('../assets/things/shield3.png');
  //   case 'shield4.png':
  //     return require('../assets/things/shield4.png');
  //   case 'shield5.png':
  //     return require('../assets/things/shield5.png');
  //   case 'shield6.png':
  //     return require('../assets/things/shield6.png');
  //   case 'shield7.png':
  //     return require('../assets/things/shield7.png');
  //   case 'shield8.png':
  //     return require('../assets/things/shield8.png');
  //   case 'shield9.png':
  //     return require('../assets/things/shield9.png');
  //   case 'shield10.png':
  //     return require('../assets/things/shield10.png');
  //   case 'shield11.png':
  //     return require('../assets/things/shield11.png');
  //   case 'shield12.png':
  //     return require('../assets/things/shield12.png');
  //   case 'shield13.png':
  //     return require('../assets/things/shield13.png');
  //   case 'shield14.png':
  //     return require('../assets/things/shield14.png');
  //   case 'shield15.png':
  //     return require('../assets/things/shield15.png');
  //   case 'shield16.png':
  //     return require('../assets/things/shield16.png');
  //   case 'shield17.png':
  //     return require('../assets/things/shield17.png');
  //   case 'shield18.png':
  //     return require('../assets/things/shield18.png');
  //   case 'shield19.png':
  //     return require('../assets/things/shield19.png');
  //   case 'shield20.png':
  //     return require('../assets/things/shield20.png');
  //   case 'shield21.png':
  //     return require('../assets/things/shield21.png');
  //   case 'shield22.png':
  //     return require('../assets/things/shield22.png');
  //   case 'shield23.png':
  //     return require('../assets/things/shield23.png');

  //   case 'sword0.png':
  //     return require('../assets/things/sword0.png');
  //   case 'sword1.png':
  //     return require('../assets/things/sword1.png');
  //   case 'sword2.png':
  //     return require('../assets/things/sword2.png');
  //   case 'sword3.png':
  //     return require('../assets/things/sword3.png');
  //   case 'sword4.png':
  //     return require('../assets/things/sword4.png');
  //   case 'sword5.png':
  //     return require('../assets/things/sword5.png');
  //   case 'sword6.png':
  //     return require('../assets/things/sword6.png');
  //   case 'sword7.png':
  //     return require('../assets/things/sword7.png');
  //   case 'sword8.png':
  //     return require('../assets/things/sword8.png');
  //   case 'sword9.png':
  //     return require('../assets/things/sword9.png');
  //   case 'sword10.png':
  //     return require('../assets/things/sword10.png');
  //   case 'sword11.png':
  //     return require('../assets/things/sword11.png');
  //   case 'sword12.png':
  //     return require('../assets/things/sword12.png');
  //   case 'sword13.png':
  //     return require('../assets/things/sword13.png');
  //   case 'sword14.png':
  //     return require('../assets/things/sword14.png');
  //   case 'sword15.png':
  //     return require('../assets/things/sword15.png');
  //   case 'sword16.png':
  //     return require('../assets/things/sword16.png');
  //   case 'sword17.png':
  //     return require('../assets/things/sword17.png');
  //   case 'sword18.png':
  //     return require('../assets/things/sword18.png');

  //   case 'scroll0.png':
  //     return require('../assets/things/scroll0.png');
  //   case 'scroll1.png':
  //     return require('../assets/things/scroll1.png');

  //   default:
  //     return null;
  // }
}
